/** @jsxImportSource @emotion/react */
import React from 'react'
import { InfoCardsForm, InfoCardsPreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/InfoCardsContext'
import { breadcrumbItems } from '../../utils'

const { index, contentManagement, infoCardsManagement } = breadcrumbItems

const InfoCardsCreate: React.FC = () => {
  return (
    <Provider>
      <div css={styles.root}>
        <div css={styles.main}>
          <InfoCardsForm />
        </div>
        <div css={styles.right}>
          <InfoCardsPreview />
        </div>
      </div>
    </Provider>
  )
}

export default InfoCardsCreate;
